import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./JobSubCategory.css"
import { JobSubCategory } from "./models/JobSubCategory";
import JobSubCategoryService from "../../admin/Shared/Services/JobSubCategoryService";
import { isFalse, isTrue, jobSubCategoryAdminCreated, jobSubCategoryUserCreated,  } from "../Shared/Constants/AdminModuleConstants";
import SweetAlertService from "../../../services/SweetAlertService";

export const ViewJobSubCategory = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [jobSubCategory, setJobSubCategory] = useState<JobSubCategory>();

    useEffect(() => {
        getJobSubCategoryById(Number(id));
    }, []);

    const getJobSubCategoryById = (id: number) => {
        JobSubCategoryService.getJobSubCategoryById(id).then((response) => {
            setJobSubCategory(response.data);
        })
            .catch(() => {
                SweetAlertService.error("Error", `Something went wrong while getting job sub-category by id ${id}`);
            });
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>JobSubCategory Details</h4>
            </div>
            <div className="card-body">
                <div className="form-group row">
                    <label className="col-sm-3 control-label"><b>Name</b></label>
                    <div className="col-sm-9">
                        {jobSubCategory?.name}
                    </div>
                </div>
                <br />
                <div className="form-group row">
                    <label className="col-sm-3 control-label"><b>SubCategory Type</b></label>
                    <div className="col-sm-9">
                        {jobSubCategory?.isSystemDefined ? jobSubCategoryAdminCreated : jobSubCategoryUserCreated}
                    </div>
                </div>
                <br />
                <div className="form-group row">
                    <label className="col-sm-3 control-label"><b>JobCategory Name</b></label>
                    <div className="col-sm-9">
                        {jobSubCategory?.jobCategoryName}
                    </div>
                </div>
                <br />
                {/*<div className="form-group row">*/}
                {/*    <label className="col-sm-3 control-label"><b>Is Default In WorkActivity</b></label>*/}
                {/*    <div className="col-sm-9">*/}
                {/*        {jobSubCategory?.isDefaultInWorkActivity ? isTrue : isFalse}*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<br />*/}
                <div className="form-group row">
                    <div className=" col-sm-offset-3">
                        <a className="btn btn-secondary"
                            onClick={() => navigate('/jobsubcategory/' + jobSubCategory?.jobCategoryId)}>
                            Back
                        </a>
                        <button className="btn btn-primary ms-1"
                            onClick={() => navigate(`/editjobsubcategory/${jobSubCategory?.id}`)}
                            type="button">
                            Edit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}